import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Channel } from '../../interfaces';
import { useChannels } from '../../queries/channels/queries';
import { useConcurrencyChannelGroup } from '../../queries/config/hooks';
import { usePlaybills } from '../../queries/playbills/queries';
import { useAuth } from '../../utils/auth-utils';
import channelPermissions from '../../utils/channelPermissions';
import { broadcastingNow } from '../../utils/huaweiUtils';
import Tv from './Tv';
export default function TvChannelsLoader() {
  const { channelId } = useParams<{ channelId: string }>();
  const { data: channels } = useChannels();

  if (!channels) {
    return null;
  }
  const currentChannel = channels.find((channel) => channel.contentId === channelId);

  if (!currentChannel) {
    return null;
  }

  return <TvProgramLoader channels={channels} currentChannel={currentChannel} />;
}

function TvProgramLoader({ channels, currentChannel }: { channels: Channel[]; currentChannel: Channel }) {
  const { data: concurrencyChannelsGroup } = useConcurrencyChannelGroup();
  const { data: playbills, refetch } = usePlaybills({ channelIds: [currentChannel.contentId], date: new Date() });
  const auth = useAuth();
  const [currentProgram, setCurrentProgram] = useState(playbills?.find(broadcastingNow));

  const handleNewPlaybills = () => {
    refetch().then((newData) => {
      if (newData.data) {
        setCurrentProgram(newData.data.find(broadcastingNow));
      }
    });
  };

  useEffect(() => {
    if (playbills) {
      setCurrentProgram(playbills.find(broadcastingNow));
    }
  }, [playbills]);

  if (!playbills) {
    return null;
  }

  return (
    <Tv
      concurrencyChannelsGroup={concurrencyChannelsGroup}
      currentChannelIsLocked={channelPermissions(currentChannel, auth).locked}
      updateCurrentLiveProgram={() => handleNewPlaybills()}
      channels={channels}
      currentChannel={currentChannel}
      currentProgram={currentProgram}
    />
  );
}
